<div class="rounded-2.5xl w-full text-center">
  <div class="px-12 md:px-24 py-6 md:py-12 border-gray-300 border-b">
    <h1 class="text-xl md:text-3xl">
      <span class="flex flex-col items-center">
        <img
          [src]="configurationService.configuration.logo"
          alt="Club logo"
          class="mb-2 h-20" />
        <span class="text-red">WELCOME!</span>
      </span>
    </h1>
  </div>
  <div class="px-12 md:px-24 py-6 md:py-12">
    <h4 class="font-normal">
      Would you like to view a quick tutorial before purchasing tickets?
    </h4>
    <div class="flex justify-center mt-5 md:mt-12">
      <button
        data-cy="dismiss-tutorial-modal-button"
        (click)="close()"
        class="disabled:opacity-30 mr-3 md:mr-6 disabled:hover:transform-none hover:scale-95 transition-transform btn-main-reverse">
        No
      </button>
      <button
        data-cy="accept-tutorial-modal-button"
        (click)="accept()"
        class="disabled:opacity-30 disabled:hover:transform-none hover:scale-95 transition-transform btn-main">
        Yes
      </button>
    </div>
    <div class="hidden md:block mt-3 small info-help">
      <span
        >For questions or assistance,<br />please call
        <b>{{ configurationService.configuration.phone }}</b
        ><br />or email
        <b>{{ configurationService.configuration.email }}</b></span
      >
    </div>
  </div>
</div>
